import { Dropdown } from "antd";
import {
  CreditCardOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { StyledHeader, HeaderContent } from "./styles";
import { ROUTES } from "../../../constant/routes";
import {
  selectSelectedTenant,
  selectUserState,
} from "../../../store/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useMemo, useState } from "react";
import { setKeyValue } from "../../../store/user/slice";
import Select from "../../generic/Select";
import Avatar from "../../generic/Avatar";
import UpdateProfile from "../../../pages/admin/User/UpdateProfile";
import ChangePassword from "../../../pages/admin/User/ChangePassword";
import XsSidebar from "./XsSidebar";
import httpClient from "../../../api/httpClient";
import { parseError } from "../../../utils/shared";
import { useNavigate } from "react-router-dom";
const TopBar = () => {
  const { tenants, selectedTenantId, loading, user } =
    useSelector(selectUserState);

  const selectedTenant = useSelector(selectSelectedTenant);
  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);

  const dispatch = useDispatch();

  const tenantOptions = useMemo(
    () =>
      Object.values(tenants).map((tenant) => ({
        value: tenant.id,
        label: tenant.name,
      })),
    [tenants],
  );

  const onLogout = useCallback(async () => {
    try {
      setSubmitting(true);

      await httpClient.post("logout", {
        refresh_token: httpClient.getRefreshToken(),
      });
    } catch (error) {
      parseError(error, true);
    } finally {
      setSubmitting(false);

      localStorage.clear();
      window.location.href = ROUTES.SIGNIN;
    }
  }, []);

  return (
    <StyledHeader
      // @ts-ignore
      sidebarCollapsed={true}
    >
      <HeaderContent>
        <div className="flex align-center">
          <div>
            <Select
              placeholder="Select Tenant"
              value={selectedTenantId}
              variant="borderless"
              style={{ flex: 1, minWidth: "100px" }}
              options={tenantOptions}
              loading={loading}
              onChange={(value) =>
                dispatch(setKeyValue({ key: "selectedTenantId", value }))
              }
            />
          </div>
          <XsSidebar />
        </div>

        <div className="flex align-center">
          <Dropdown
            menu={{
              items: [
                {
                  key: "profile",
                  label: <UpdateProfile />,
                },
                {
                  key: "changePassword",
                  label: <ChangePassword />,
                },
                ...(selectedTenant?.role === "OWNER"
                  ? [
                      {
                        key: "billing",
                        icon: <CreditCardOutlined />,
                        label: "Billing",
                        onClick: () =>
                          navigate(
                            `${ROUTES.BILLING}?tenant_id=${selectedTenant?.id}`,
                          ),
                      },
                    ]
                  : []),
                {
                  key: "settings",
                  icon: <SettingOutlined />,
                  label: "Settings",
                  onClick: () => navigate(ROUTES.BUSINESS),
                },
                {
                  type: "divider",
                },
                {
                  key: "logout",
                  icon: <LogoutOutlined />,
                  label: "Logout",
                  disabled: submitting,
                  danger: true,
                  onClick: onLogout,
                },
              ],
            }}
            trigger={["click"]}
          >
            <Avatar user={user} size={38} className="cursor-pointer" />
          </Dropdown>
        </div>
      </HeaderContent>
    </StyledHeader>
  );
};

export default TopBar;
